// extracted by mini-css-extract-plugin
export default {"wrapper":"SiteInstitutionsList_wrapper","institution":"SiteInstitutionsList_institution"};